export default __webpack_public_path__ + "static/media/20241128_OEPV_CGU.bf309b07.pdf";